<template>
  <v-pagination v-model="page" :length="length" :total-visible="10"/>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "Pagination",
    props: {
      value: Number,
      length: Number
    },
    computed: {
      page: {
        get () {
          return this.value;
        },
        set (value) {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      }
    }
  }
</script>

<style scoped>

</style>